import 'date-fns'
import React from 'react'
import DateFnsUtils from '@date-io/date-fns'
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker
} from '@material-ui/pickers'
import PropTypes from 'prop-types'

/**
 * The `DatePicker` component wrap https://material-ui-pickers.dev/demo/datepicker.
 *
 * It also inherit the https://material-ui.com/api/text-field/#props
 *
 * On mobile, pickers are best suited for display in confirmation dialog.
 *
 * Only important or basic options has been added in propTypes.
 * You can still use the other features of material-ui if supported by the current version of our design system.
 *
 * Using or adding new options that is not on the propTypes please notify the Front-End Architect
 */

const DatePicker = props => {
  const {
    ariaLabel,
    id,
    variant,
    value,
    format,
    label,
    allowKeyboardControl,
    onChange,
    ...rest
  } = props

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <KeyboardDatePicker
        data-cid='DatePicker-root'
        variant={variant}
        format={format}
        id={id}
        label={label}
        allowKeyboardControl={allowKeyboardControl}
        value={value}
        onChange={onChange}
        KeyboardButtonProps={{
          'aria-label': { ariaLabel }
        }}
        {...rest}
      />
    </MuiPickersUtilsProvider>
  )
}

DatePicker.propTypes = {
  /** Use the naming standards. */
  id: PropTypes.string.isRequired,
  /** Accessible name  */
  ariaLabel: PropTypes.string.isRequired,
  /**
   * Picker value
   *
   * type: ParsableDate
   * */
  value: PropTypes.any.isRequired,
  /**
   * Keyboard onChange callback
   *
   * type: (date: DateIOType, value?: string | null) => void
   * */
  onChange: PropTypes.any.isRequired,
  /** Enables keyboard listener for moving between days in calendar. */
  allowKeyboardControl: PropTypes.bool,
  /** Auto accept date on selection. */
  autoOk: PropTypes.bool,
  /** Disable picker and text field. */
  disabled: PropTypes.bool,
  /** Disable future dates. */
  disableFuture: PropTypes.bool,
  /** Disable past dates. */
  disablePast: PropTypes.bool,
  /** Hide toolbar and show only date/time views. */
  disableToolbar: PropTypes.bool,
  /** Format string */
  format: PropTypes.string,
  /** Label of the picker */
  label: PropTypes.string,
  /** The size of the checkbox. small is equivalent to the dense checkbox styling. */
  variant: PropTypes.oneOf(['dialog', 'inline', 'static']),
  /** Available only with variant "dialog"
   *
   * Show clear action in picker dialog
   */
  clearable: PropTypes.bool
}

DatePicker.defaultProps = {
  variant: 'dialog',
  format: 'yyyy-MM-dd',
  allowKeyboardControl: true,
  autoOk: false,
  disabled: false,
  disableFuture: false,
  disablePast: false,
  disableToolbar: false
}

export default DatePicker
